import { useState, useRef } from "react";
import { Autocomplete, TextField, Chip, Box, Tooltip, Checkbox } from "@mui/material";
import PropTypes from "prop-types";
import CustomAvatar from "../../../../../reusable-components/custom-avatar/CustomAvatar";

MobileUsers.propTypes = {
  userOptions: PropTypes.array,
  ticketUsers: PropTypes.array,
  addUser: PropTypes.func,
  removeUser: PropTypes.func,
}
export default function MobileUsers({userOptions, ticketUsers, addUser, removeUser}) {
  const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
  const [showMoreTooltip, setShowMoreTooltip] = useState(false);
  const autocompleteRef = useRef(null);

  return <Autocomplete
    options={userOptions || []}
    multiple
    disableClearable
    ref={autocompleteRef}
    freeSolo
    getOptionLabel={option => typeof option === 'string' ? option : option.value || option.id}
    value={ticketUsers}
    onChange={(_, newValue) => {
      const lastValue = newValue[newValue.length - 1];
      let updatedUsers = newValue;
      if (typeof lastValue === "string") {
        updatedUsers = [
          ...newValue.slice(0, -1),
          { id: lastValue, value: lastValue, email: lastValue }
        ];
        addUser(updatedUsers);
      }
    }}
    open={isAutocompleteOpen}
    onOpen={() => setIsAutocompleteOpen(true)}
    onClose={() => setIsAutocompleteOpen(false)}
    renderOption={(props, option) => (
      <li {...props} key={option.id || option} style={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          checked={ticketUsers.some(u => u.email === option.id || u.id === option.id)}
          style={{ marginRight: 8 }}
            onChange={(e) => {
              if (!e.target.checked) {
                removeUser(ticketUsers.find(u => u.email === option.id || u.id === option.id)?.id);
              }
              else {
                addUser([...ticketUsers, option]);
              }
            }
          }
        />
        {option.value || option}
      </li>
    )}
    sx={{
      '& .MuiInputBase-root.MuiOutlinedInput-root': {
        padding: 0
      },
      '& .MuiAutocomplete-tag': {
        margin: 0.2,
      },
    }}
    renderTags={(value, getTagProps) =>
      value.slice(0, 4).map((option, index) => (
        <Box key={option.id || option} sx={{ display: 'flex', alignItems: 'center' }}>
          <Chip
            key={option.id || option}
            {...getTagProps({ index })}
            label={option.value || option}
            onDelete={() => ticketUsers?.length > 1 && removeUser(option.id || option)}
            avatar={
              <CustomAvatar
                name={option?.value || option?.id || option}
                email={option?.email || option?.id || option}
                index={index}
                sx={{ '&.MuiChip-avatar': { color: '#fff !important' } }}
              />
            }
            sx={{ mb: 0.5, maxWidth: '180px' }}
          />
          {value.length > 4 && index === 3 && (
            <Tooltip
              open={showMoreTooltip}
              onClose={() => setShowMoreTooltip(false)}
              title={
                <Box>
                  {value.slice(4).map((user) => (
                    <div key={user.id || user}>{user.value || user}</div>
                  ))}
                </Box>
              }
            >
              <Chip
                label={`+${value.length - 4}`}
                onClick={() => setShowMoreTooltip(true)}
                sx={{ cursor: 'pointer' }}
              />
            </Tooltip>
          )}
        </Box>
      ))
    }
    renderInput={(params) => 
      <TextField
        {...params} size="small"
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: 0,
            '& fieldset': {
              padding: 0,
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
        }}
      />
    }
  />
}